import { useState } from 'react';

/** Estado do "Mostrar valores" de um gráfico de linha: começa desligado (último dia e extremos). */
export function useMostrarValores(): [boolean, () => void] {
  const [ativo, setAtivo] = useState(false);
  return [ativo, () => setAtivo((a) => !a)];
}
